import { IBill } from "../interface/IBill";

export interface IBillResponse {
    amount: number;
    dueDate: string;
    invoiceDate: string;
    invoiceNumber: number;
}

export const getResponseToState = (response: IBillResponse[] | undefined): IBill[] | undefined =>
    response?.map((bill) => ({
        amount: bill.amount,
        dueDate: bill.dueDate,
        invoiceDate: bill.invoiceDate,
        invoiceNumber: bill.invoiceNumber,
    }));
